import { render, staticRenderFns } from "./editorwarehouse.vue?vue&type=template&id=cc0874e2"
import script from "./editorwarehouse.vue?vue&type=script&lang=js"
export * from "./editorwarehouse.vue?vue&type=script&lang=js"
import style0 from "./editorwarehouse.vue?vue&type=style&index=0&id=cc0874e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports